// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c64801d3","modalContainer":"b5239ba7"};